var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v(_vm._s(_vm.$t('notFound.unknownPage')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }